import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5aa42b12")

_pushScopeId("data-v-5aa42b12")
const _hoisted_1 = { class: "min-h-full pt-16 pb-12 flex flex-col p-3" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "py-16" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-sm font-semibold text-bp-light uppercase tracking-wide" }
const _hoisted_6 = { class: "mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl" }
const _hoisted_7 = { class: "mt-2 text-base text-gray-500" }
const _hoisted_8 = { class: "mt-6 text-" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, " →", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("main", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("error.NotFoundComponent.error404")), 1),
          _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("error.NotFoundComponent.pageNotFound")), 1),
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("error.NotFoundComponent.pageNotFoundDetail")), 1),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "text-base font-medium text-bp-light hover:text-bp-lightest#",
              to: "/"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("error.NotFoundComponent.backHomeBtn")), 1),
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
})